import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValuePropsSmartComponent } from './value-props-smart/value-props-smart.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ValuePropsDropdownComponent } from './value-props-dropdown/value-props-dropdown.component';
import { ValuePropItemComponent } from './value-prop-item/value-prop-item.component';

@NgModule({
  declarations: [
    ValuePropsSmartComponent,
    ValuePropsDropdownComponent,
    ValuePropItemComponent,
  ],
  imports: [
    CommonModule,
    DragDropModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCardModule,
  ],
  exports: [
    ValuePropsSmartComponent,
  ],
})
export class FinancingValuePropsModule {}
